import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '@/views/HomePage.vue';

import {Grille} from "@/router/Grille/Grille.js";
import {Worker} from "@/router/Worker.js";

import {PaySlip, BlankPaySlip} from "@/router/PaySlip.js";
import {PaySlipAnnex} from "@/router/PaySlipAnnex.js";
import {Debt} from "@/router/Debt.js";
import {PayDayAdvance} from "@/router/PayDayAdvance.js";
import {Bank} from "@/router/Bank.js";

import {Notification} from "@/views/Notification/router/Notification.js";
import {Issue} from "@/views/Notification/router/Issue.js";

import {ValidationWorkFlow} from "@/router/Absence/ValidationWorkFlow.js";
import {ValidationWorkFlowAction} from "@/router/Request/ValidationWorkFlowAction.js";
import {AbsenceRequest, AbsenceRequestCalendar, AbsenceRequestBalance} from "@/router/Absence/AbsenceRequest.js";
import {Vacation, VacationCalendar, VacationBalance} from "@/router/Absence/Vacation.js";
import {Claim} from "@/router/Request/Claim.js";
import {AdminRequest} from "@/router/Request/AdminRequest.js";
import {RecruitmentRequest} from "@/router/Request/RecruitmentRequest.js";

import {RecruitmentSourcing, RecruitmentSourcingAdd} from "@/router/Recruitment/RecruitmentSourcing.js";
import {RecruitmentCvTech} from "@/router/Recruitment/RecruitmentCvTech.js";
import {RecruitmentPlanning} from "@/router/Recruitment/RecruitmentPlanning.js";
import {RecruitmentEvaluation} from "@/router/Recruitment/RecruitmentEvaluation.js";
import {RecruitmentDecision} from "@/router/Recruitment/RecruitmentDecision.js";

import {OnBoarding} from "@/router/Boarding/OnBoarding.js";
import {OffBoarding} from "@/router/Boarding/OffBoarding.js";
import {BoardingTask} from "@/router/Boarding/BoardingTask.js";

import {OrganizationalChart} from "@/router/OrganizationalChart.js";
import {Contrat} from "@/router/Contrat.js";
import {ContratTemplate} from "@/router/ContratTemplate.js";

import {Parameter} from "@/router/Parameter/Parameter.js";

import {TrainingRequest} from "@/router/Training/TrainingRequest.js";
import {TrainingRequestCatalog} from "@/router/Training/TrainingRequestCatalog.js";
import {TrainingPlan} from "@/router/Training/TrainingPlan.js";
import {TrainingPlanDetails} from "@/router/Training/TrainingPlanDetails.js";
import {TrainingSession, TrainingHotEvaluation, TrainingColdEvaluation} from "@/router/Training/TrainingSession.js";

import {EvaluationSkillDirectory} from "@/router/Evaluation/Skill/EvaluationSkillDirectory.js";
import {EvaluationSkillFramework} from "@/router/Evaluation/Skill/EvaluationSkillFramework.js";
import {EvaluationSkillGoalFile} from "@/router/Evaluation/Skill/EvaluationSkillGoalFile.js";
import {EvaluationSkill, EvaluationSkillCandidate} from "@/router/Evaluation/Skill/EvaluationSkill.js";

import {EvaluationPerformanceGoalFile} from "@/router/Evaluation/Performance/EvaluationPerformanceGoalFile.js";
import {EvaluationPerformance, EvaluationPerformanceCandidate} from "@/router/Evaluation/Performance/EvaluationPerformance.js";

import {MedicalCompanion} from "@/router/Medical/MedicalCompanion.js";
import {MedicalAppointment} from "@/router/Medical/MedicalAppointment.js";

import {Document} from "@/router/Edms/Document.js";
import {TemplateApplication} from "@/router/Edms/TemplateApplication.js";

import {Impression} from "@/router/Impression/Impression.js";

import { Intranet } from '@/router/Intranet/Intranet.js';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage,
        children: [
            Notification,
            Issue,
            Parameter,
            Contrat,
            ContratTemplate,
            OrganizationalChart,
            Worker,
            Grille,
            PaySlip,
            BlankPaySlip,
            PaySlipAnnex,
            Debt,
            PayDayAdvance,
            Bank,

            ValidationWorkFlow,
            ValidationWorkFlowAction,
            Claim,
            AdminRequest,
            AbsenceRequest,
            RecruitmentRequest,
            AbsenceRequestCalendar,
            AbsenceRequestBalance,
            Vacation,
            VacationCalendar,
            VacationBalance,

            RecruitmentSourcing,
            RecruitmentSourcingAdd,
            RecruitmentCvTech,
            RecruitmentPlanning,
            RecruitmentEvaluation,
            RecruitmentDecision,

            OnBoarding,
            OffBoarding,
            BoardingTask,

            TrainingRequest,
            TrainingRequestCatalog,
            TrainingPlan,
            TrainingPlanDetails,
            TrainingSession,
            TrainingHotEvaluation,
            TrainingColdEvaluation,

            EvaluationPerformanceGoalFile,
            EvaluationPerformance,
            EvaluationPerformanceCandidate,

            EvaluationSkillDirectory,
            EvaluationSkillFramework,
            EvaluationSkillGoalFile,
            EvaluationSkill,
            EvaluationSkillCandidate,

            MedicalCompanion,
            MedicalAppointment,

            Document,
            TemplateApplication,

            Impression,

            {
                path: '/print',
                name: 'print',
                component: () => import('../views/PaySlip/Form/PrintPaySlip.vue'),
            },
        ]
    },
    Intranet,
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Setting/Login/LoginPage.vue'),
        children: [
            {
                path: '/login/folders/open/:folder_name',
                name: 'login.folders.open',
                component: () => import('@/views/Folder/Form/OpenFolder.vue'),
                props: {add_action: true}
            },
        ],
    },
    {
        path: '/reset_password',
        name: 'reset_password',
        component: () => import('@/views/Setting/ResetPassword/ResetPasswordPage.vue'),
    },
    {
        path: '*',
        name: 'not_found',
        component: () => import('@/views/NotFoundPage.vue')
    },
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
